// removed by extract-text-webpack-plugin
module.exports = {"visible-xs":"visible-xs___1YidN","visible-sm":"visible-sm_____tms","visible-md":"visible-md___3PolS","visible-lg":"visible-lg___3BQY_","row":"row___1Vn89","hidden-xs":"hidden-xs___23SN8","hidden-sm":"hidden-sm___3NoFQ","hidden-md":"hidden-md___IGqei","hidden-lg":"hidden-lg___2f5nt","page":"page___QuYdv page___2ZhHk","title":"title___3rzMi","copy":"copy___3i0Dv h3___5u0xZ","data-link":"data-link___39uOQ space-top-8___2eGOi","data-link-in":"data-link-in___2i36Q center___2iqBf"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Data/Data.css
// module id = 948
// module chunks = 0